import { useReduxState } from 'hooks';
import { CopyButton } from 'components/common';

import type { UserCustomAttribute } from 'shared-types';

interface Props {
  attributes: UserCustomAttribute[];
}

const UserAttributesExport = ({ attributes }: Props) => {
  const { messages } = useReduxState();

  const value = JSON.stringify(attributes);

  return (
    <CopyButton
      icon="copy"
      isDropdown={true}
      text={messages.commonExportData}
      successText={messages.commonCopied}
      style={{ width: '100%' }}
      value={value}
    />
  );
};

export default UserAttributesExport;
